import { cn } from '../../lib/cn';
import { Badge, Card } from '../ui';
import type { TaskItem } from '../../exechome/framework';

type Props = {
  tasks?: TaskItem[];
  className?: string;
};

function priorityVariant(p?: string) {
  if (p === 'critical') return 'error' as const;
  if (p === 'high') return 'warning' as const;
  return 'default' as const;
}

export function TaskCenterWidget({ tasks = [], className }: Props) {
  return (
    <Card className={cn(className)} padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Task Center</p>
      <ul className="mt-3 space-y-2">
        {tasks.map((t) => (
          <li key={t.id} className="flex items-start justify-between gap-2 rounded-lg border border-slate-200 p-2 dark:border-slate-700">
            <div>
              <p className="text-sm font-medium text-slate-900 dark:text-slate-100">{t.title}</p>
              <div className="mt-1 flex flex-wrap gap-1">
                <Badge variant="info">{t.category.replace(/_/g, ' ')}</Badge>
                {t.due && <span className="text-xs text-slate-500">Due: {t.due}</span>}
              </div>
            </div>
            {t.priority && <Badge variant={priorityVariant(t.priority)}>{t.priority}</Badge>}
          </li>
        ))}
      </ul>
    </Card>
  );
}
